import Button from 'components/button/Button';
import LinkButton from './LinkButton';

// Funky CSS happening here
// On desktop, it will take the shape of the button, which has a minWidth of 180px
// On mobile, column will be full width. Button will fill entire width of screen

export default ({
  onClick,
  error,
  loading,
  width = '100%',
  minWidth = '180px',
  disabled = false,
  children,
  href,
  className,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  height,
  color,
  activeColor,
  centered = true,
  justify,
  id,
  secondary,
  openLinkInSameTab,
  type
}) => {
  return (
    <div className={`columns submit-button ${centered ? 'is-centered' : ''}`}>
      <div className="column is-narrow">
        {href ? (
          <LinkButton
            id={id}
            onClick={onClick}
            error={error}
            loading={loading}
            disabled={disabled}
            minWidth={minWidth}
            width={width}
            children={children}
            href={href}
            className={className}
            marginTop={marginTop}
            marginBottom={marginBottom}
            height={height}
            color={color}
            activeColor={activeColor}
            openLinkInSameTab={openLinkInSameTab}
          />
        ) : (
          <Button
            id={id}
            onClick={onClick}
            error={error}
            loading={loading}
            disabled={disabled}
            minWidth={minWidth}
            width={width}
            children={children}
            className={className}
            marginTop={marginTop}
            marginBottom={marginBottom}
            marginLeft={marginLeft}
            marginRight={marginRight}
            height={height}
            color={color}
            activeColor={activeColor}
            type={type ? type : 'submit'}
            secondary={secondary}
          />
        )}
      </div>
    </div>
  );
};
